<template>
  <div>
    <v-row>
      <v-col cols="12">
        <ReportsFilters @filter="filterBy" :loading="loading" />
      </v-col>

      <v-col cols="12">
        <v-row>
          <v-col
            cols="12"
            lg="auto"
            class="text-start"
            style="display: flex; align-items: center"
          >
            <span class="textLight--text font-weight-medium text-h5">
              {{ $t("batch.batchCompletion") }}
            </span>
          </v-col>

          <v-spacer></v-spacer>

          <v-col cols="12" lg="auto">
            <reports-sub-filters
              @exportToExcel="exportToXL"
              @filter="filterBy"
              :exportBtnLoading="exporting"
              :disable="disableSubFilters"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div class="mt-5" style="overflow-x: auto; overflow-y: hidden">
      <div>
        <v-card
          flat
          class="rounded-lg primary--text px-6 py-3"
          style="min-width: 100%; max-width: fit-content; width: fit-content"
        >
          <div
            class="text-center d-flex align-center"
            style="width: fit-content"
          >
            <div class="text-start pe-3" style="width: 250px">
              {{ $t("user.registration.organization") }}
            </div>

            <div class="text-start pe-3" style="width: 150px">
              {{ $t("batch.batchNumber") }}
            </div>

            <div class="text-start pe-3" style="width: 250px">
              {{ $t("course.trainer") }}
            </div>

            <div class="text-start pe-3" style="width: 250px">
              {{ $t("reports.training") }}
            </div>

            <div class="text-center pe-3" style="width: 150px">
              {{ $t("batch.numberOfEmployees") }}
            </div>

            <div class="text-start pe-3" style="width: 120px">
              {{ $t("batch.date") }}
            </div>

            <div class="text-start pe-3" style="width: 150px">
              {{ $t("batch.purchaseOrder") }}
            </div>

            <div class="text-start pe-3" style="width: 180px">
              {{ $t("batch.certificateDelivery") }}
            </div>

            <div class="text-start pe-3" style="width: 180px">
              {{ $t("batch.invoiceSubmission") }}
            </div>

            <div class="text-start pe-3" style="width: 150px">
              {{ $t("batch.paymentStatus") }}
            </div>

            <div>
              <v-btn icon depressed color="error" style="visibility: hidden">
                <v-icon> mdi-trash-can-outline </v-icon>
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>

      <div v-if="!loading && dataList.length">
        <div v-for="(data, index) in dataList" :key="index">
          <BatchReportCard :batchData="data" />
        </div>
      </div>

      <div
        v-else-if="!loading && !dataList.length"
        class="textLight--text font-weight-medium my-16"
      >
        {{ $t("noItems") }}
      </div>

      <div v-else-if="loading && !dataList.length" class="my-16">
        <v-progress-circular indeterminate color="primary" />
      </div>
    </div>

    <v-row class="mt-3">
      <v-col cols="12" v-if="dataList && dataList.length">
        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { excelExport } from "../methods/excelExport";

import ReportsFilters from "./ReportsFilters.vue";
import ReportsSubFilters from "./ReportsSubFilters.vue";
import Pagination from "../../core-module/components/Pagination.vue";
import BatchReportCard from "./BatchReportCard.vue";

export default {
  name: "BatchReports",
  components: {
    ReportsFilters,
    ReportsSubFilters,
    Pagination,
    BatchReportCard,
  },
  data() {
    return {
      loading: true,
      dataList: [],
      pageInput: this.defaultPageInput(),
      exporting: false,
      exportAsXl: false,
      totalCount: null,
      organization: null,
      training: null,
      trainer: null,
      employee: null,
      datesRange: {
        startDate: null,
        endDate: null,
      },
      search: null,
      disableSubFilters: true,
      debounceSearch: null,
      totalPages: 0,
    };
  },
  apollo: {
    getBatches() {
      return {
        query: require("../../batch-module/api/query/getBatches.gql"),
        variables: this.getVariables(),
        result({ data, loading }) {
          if (data?.getBatches?.batches) {
            this.dataList = data.getBatches.batches;
            this.totalCount = data.getBatches.totalCount;

            const pagesVal = this.totalCount / this.pageInput.limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;

            this.disableSubFilters = !this.dataList.length;
          }

          this.loading = loading;
        },
      };
    },
  },
  methods: {
    getVariables() {
      let filterInput;

      if (this.search) {
        filterInput = { ...filterInput, search: this.search };
      }

      if (this.training) {
        filterInput = { ...filterInput, training: this.training };
      }

      if (this.trainer) {
        filterInput = { ...filterInput, trainer: this.trainer };
      }

      if (this.organization) {
        filterInput = { ...filterInput, organization: this.organization };
      }

      if (this.employee) {
        filterInput = { ...filterInput, employee: this.employee };
      }

      if (this.datesRange.startDate) {
        filterInput = { ...filterInput, dateFrom: this.datesRange.startDate };
      }

      if (this.datesRange.endDate) {
        filterInput = { ...filterInput, dateTo: this.datesRange.endDate };
      }

      return {
        pageInput: this.pageInput,
        filterInput,
      };
    },
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },
    onPagination(val) {
      if (val > 0) {
        this.pageInput.skip = this.pageInput.limit * (val - 1);
        this.refetch();
      }
    },
    onProgress(event) {
      if (event === 100) {
        this.exporting = false;
      }
    },
    filterBy(key, value) {
      if (key === "organization") {
        this.organization = value;
        this.pageInput = this.defaultPageInput();
        this.refetch();
      }

      if (key === "search") {
        clearTimeout(this.debounceSearch);
        this.debounceSearch = setTimeout(() => {
          this.apiSearch(value);
        }, 500);
      }

      if (key === "training") {
        this.training = value;
        this.pageInput = this.defaultPageInput();
        this.refetch();
      }

      if (key === "trainer") {
        this.trainer = value;
        this.pageInput = this.defaultPageInput();
        this.refetch();
      }

      if (key === "employee") {
        this.employee = value;
        this.pageInput = this.defaultPageInput();
        this.refetch();
      }

      if (key === "dates") {
        this.datesRange.startDate = value.startDate;
        this.datesRange.endDate = value.endDate;
        this.pageInput = this.defaultPageInput();
        this.refetch();
      }
    },
    apiSearch(val) {
      const searchText = val?.trim() ?? "";

      if (searchText.length > 0) {
        this.search = searchText;
        this.pageInput = this.defaultPageInput();
        this.refetch();
      } else if (searchText.length === 0 && this.search != null) {
        this.search = null;
        this.pageInput = this.defaultPageInput();
        this.refetch();
      }
    },
    async exportToXL() {
      this.exporting = true;

      const exportArr = await this.$apollo
        .query({
          query: require("../../batch-module/api/query/getBatches.gql"),
          variables: {
            ...this.getVariables(),
            pageInput: { skip: 0, limit: 0 },
          },
        })
        .then(result => {
          this.exporting = false;

          if (result?.data?.getBatches?.batches) {
            return result.data.getBatches.batches.map(batch => {
              let obj = {};

              obj[this.$t("user.registration.organization")] =
                this.getLocalisedValue(batch.organizationName, {
                  emptyNotation: "-",
                });

              obj[this.$t("batch.batchNumber")] = batch.UID;

              obj[this.$t("batch.status")] = batch.status;

              obj[this.$t("course.trainer")] = batch.trainerName;

              obj[this.$t("reports.training")] = this.getLocalisedValue(
                batch.trainingTitle,
                { emptyNotation: "-" }
              );

              obj[this.$t("batch.numberOfEmployees")] = batch.employees.length;

              obj[this.$t("batch.employees")] = batch.employees
                .map(x => x.employeeName)
                .join(", ");

              obj[this.$t("batch.date")] = batch.startDate
                ? this.$moment(parseInt(batch.startDate)).format("DD MMM YYYY")
                : "-";

              obj[this.$t("batch.purchaseOrder")] = batch.purchaseInfo?.status;
              obj[this.$t("batch.purchaseOrderMarkedAt")] = batch.purchaseInfo
                ?.markedAt
                ? this.$moment(parseInt(batch.purchaseInfo?.markedAt)).format(
                    "DD MMM YYYY hh:mm a"
                  )
                : "-";

              obj[this.$t("batch.certificateDelivery")] =
                batch.certificateInfo?.status;
              obj[this.$t("batch.certificateDeliveryMarkedAt")] = batch
                .certificateInfo?.markedAt
                ? this.$moment(
                    parseInt(batch.certificateInfo?.markedAt)
                  ).format("DD MMM YYYY hh:mm a")
                : "-";

              obj[this.$t("batch.invoiceSubmission")] =
                batch.invoiceInfo?.status;
              obj[this.$t("batch.invoiceSubmissionMarkedAt")] = batch
                .invoiceInfo?.markedAt
                ? this.$moment(parseInt(batch.invoiceInfo?.markedAt)).format(
                    "DD MMM YYYY hh:mm a"
                  )
                : "-";

              obj[this.$t("batch.paymentStatus")] = batch.paymentInfo?.status;
              obj[this.$t("batch.paymentStatusMarkedAt")] = batch.paymentInfo
                ?.markedAt
                ? this.$moment(parseInt(batch.paymentInfo?.markedAt)).format(
                    "DD MMM YYYY hh:mm a"
                  )
                : "-";

              return obj;
            });
          }
        });

      const fileName = `batch-completion-reports-${Date.now()}`;
      excelExport(exportArr, fileName);
    },
    async refetch() {
      await this.$apollo.queries.getBatches.refetch(this.getVariables());
    },
  },
};
</script>
